// extracted by mini-css-extract-plugin
module.exports = {"dropMenu":"DropMenu_dropMenu__A5v-Q","right":"DropMenu_right__3MtMc","left":"DropMenu_left__x-39-","bottom":"DropMenu_bottom__Bg7zR","overlay":"DropMenu_overlay__1XIDd"};